import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=47b234dc&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/faq.css?vue&type=style&index=0&id=47b234dc&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/fonts.css?vue&type=style&index=1&id=47b234dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b234dc",
  null
  
)

export default component.exports